import { useState, useEffect } from 'react'
import apiClient from '../../services/apiClient'
import Layout from '../../components/Layout'
import AdminTabs from '../../components/AdminTabs'
import CrudTable from '../../components/CrudTable'
import Spinner from '../../components/Spinner'

export default function AdminProductLifecycles() {
  const [items, setItems]     = useState([])
  const [loading, setLoading] = useState(true)
  const load = () => {
    setLoading(true)
    apiClient.get('/admin/product-lifecycles?include_inactive=true').then((r) => setItems(r.data.items)).finally(() => setLoading(false))
  }
  useEffect(() => { load() }, [])

  return (
    <Layout>
      <div className="page-header">
        <h1 className="page-title">Admin</h1>
      </div>
      <AdminTabs />
      {loading ? (
        <div className="loading-state"><Spinner size="md" /> Loading…</div>
      ) : (
        <div className="card">
        <CrudTable
          items={items}
          columns={[
            { key: 'id',            label: 'ID' },
            { key: 'name',          label: 'Name', editable: true },
            { key: 'display_order', label: 'Order', editable: true },
            { key: 'is_active',     label: 'Active', editable: true, type: 'boolean' },
          ]}
          newItemFields={[
            { key: 'name',          label: 'Name' },
            { key: 'display_order', label: 'Order', type: 'number', default: 0 },
          ]}
          onCreate={async (data) => {
            await apiClient.post('/admin/product-lifecycles', { ...data, display_order: Number(data.display_order) })
            load()
          }}
          onUpdate={async (id, data) => {
            await apiClient.put(`/admin/product-lifecycles/${id}`, { name: data.name, display_order: Number(data.display_order), is_active: Number(data.is_active) })
            load()
          }}
          onDelete={async (id) => { await apiClient.delete(`/admin/product-lifecycles/${id}`); load() }}
        />
        </div>
      )}
    </Layout>
  )
}

